// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"eb242f7e","845":"cb0e1db9"}[chunkId] + ".chunk.js";
};